import head from 'lodash/head';
import pipe from 'lodash/fp/pipe';
import getOr from 'lodash/fp/getOr';

export const hasActiveRegister = state => state.register.cashRegister.hasActiveRegister;
export const getActiveRegisterStartBalance = state => state.register.cashRegister.activeRegister.startBalance;
export const getRegisterTransactions = state => state.register.cashRegister.transactions;
export const getCashRegisterHistory = state => state.register.cashRegister.history;
export const getActiveRegisterCurrentBalance = (state) => {
  const start = getActiveRegisterStartBalance(state);
  const transactions = getRegisterTransactions(state);
  return start + transactions.reduce((sum, item) => sum + item.amount, 0);
};
const getFirstCashRegisterHistoryEntry = state => head(state.register.cashRegister.history);
export const getLastClosedCashRegisterBalance = pipe(
  getFirstCashRegisterHistoryEntry,
  getOr(0, 'actualEndBalance'),
);
export const getActiveCashRegister = state => state.register.cashRegister.activeRegister;

export const getActiveCashRegisterOpenDate = pipe(
  getActiveCashRegister,
  getOr(null, 'openedAt'),
);
